import React from "react";
import { Spinner } from "react-bootstrap";

const ButtonLoader = ({ onClick, text, isLoading, className = "button" }) => {
  return (
    <>
      <button
        className={className}
        onClick={onClick}
        disabled={isLoading}
        type="submit"
      >
        {isLoading ? (
          <Spinner animation="border" role="status" variant="primary"></Spinner>
        ) : (
          text
        )}
      </button>
    </>
  );
};

export default ButtonLoader;

export const ButtonLoading = ({ onClick, text, isLoading, disabled, className = "button" }) => {
  return (
    <>
      <button
        className={className}
        onClick={onClick}
        disabled={disabled}
        type="submit"
      >
        {isLoading ? (
          <Spinner animation="border" role="status" variant="primary"></Spinner>
        ) : (
          text
        )}
      </button>
    </>
  );
};